module.exports = __webpack_public_path__ + "img/Art02-19710261-0056.7ea0b13d.jpg";